import {
  Dashboardv20240509Api,
  dashboardv20240509Client
} from '@sequencehq/api/dashboard/v20240509'
import { fetchQuery } from '@sequencehq/api'
import { useCallback } from 'react'
import { apiQueryClient } from 'features/api/apiQueryClient'
import { MINUTES } from '@sequencehq/utils/dates'

export type v1ApiPrice = Dashboardv20240509Api.GetPrice.Price

type UseLoadPrices = () => (props: {
  priceIds: Array<v1ApiPrice['id']>
}) => Promise<{
  prices: v1ApiPrice[]
}>

export const useLoadPrices: UseLoadPrices = () => {
  const load = useCallback(
    async ({ priceIds }: { priceIds: Array<string> }) => {
      const prices = (
        await Promise.all(
          priceIds.map(priceId =>
            fetchQuery(
              apiQueryClient,
              dashboardv20240509Client.getPrice,
              { id: priceId },
              { staleTime: 10 * MINUTES }
            )
          )
        )
      ).filter((price): price is v1ApiPrice => Boolean(price))

      return {
        prices
      }
    },
    []
  )

  return load
}
